<template>
    <div class="w-full relative items-center px-6 lg:h-20 border-b">
        <div class="max-w-7xl py-4 md:py-8 w-full flex justify-center items-center mx-auto">
            <h4 class="text-yank">Location Settings</h4>
        </div>

        <div class="flex flex-col px-4 md:px-6 pt-4 pb-6 md:pt-6 md:pb-8">
            <span class=" font-semibold text-sm mb-2">Timezone</span>
            <select class="w-full md:w-6/12 rounded-lg mb-6 focus:outline-none cursor-pointer" >
                <option :selected="true"><span class=" text-sm">Coordinated Universal Time (UTC)</span> </option>
            </select>
            <button type="submit" class="h-11 md:h-12 w-full md:w-3/12 px-8 md:px-16 text-sm text-white font-semibold rounded-xl bg-aquamarine hover:opacity-90 transition focus:outline-none focus:ring-2 focus:ring-aquamarine focus:ring-offset-2 disabled:opacity-60 flex items-center justify-center disabled:bg-payneFire" >
                <span>Save</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name:"LocationSetting",
    data() {
        return {
            key: (value ? value : null)
        }
    },
}
</script>